export const LINE_GRAPH_THEME = {
  background: 'transparent',
  fontFamily: 'IBM Plex Mono, monospace',
  fontSize: 11,
  textColor: 'var(--ctx-theme-contrast-page-200)',
  axis: {
    domain: {
      line: {
        stroke: '#98a7cb',
        strokeWidth: 1
      }
    },
    ticks: {
      line: {
        stroke: '#98a7cb',
        strokeWidth: 1
      },
      text: {}
    },
    legend: {
      text: {
        fontSize: 12,
        color: 'var(--ctx-theme-contrast-page-200)'
      }
    }
  },
  grid: {
    line: {
      stroke: '#98a7cb',
      strokeWidth: 1
    }
  },
  legends: {
    text: {
      fill: 'var(--ctx-theme-contrast-page-200)'
    },
    textColor: 'var(--ctx-theme-contrast-page-200)'
  },
  labels: {
    text: {
      color: 'var(--ctx-theme-contrast-page-200)'
    }
  },
  markers: {
    lineColor: '#000000',
    lineStrokeWidth: 1,
    text: {}
  },
  dots: {
    text: {}
  },
  tooltip: {
    container: {
      background: 'var(--ctx-theme-color-page-200)',
      color: 'var(--ctx-theme-contrast-page-200)',
      fontSize: 'inherit',
      borderRadius: '2px',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
      padding: '5px 9px'
    },
    basic: {
      whiteSpace: 'pre',
      display: 'flex',
      alignItems: 'center'
    },
    table: {},
    tableCell: {
      padding: '3px 5px'
    }
  },
  crosshair: {
    line: {
      stroke: 'var(--ctx-theme-contrast-page-200)',
      strokeWidth: 1,
      strokeOpacity: 0.75,
      strokeDasharray: '6 6'
    }
  },
  annotations: {
    text: {
      fontSize: 13,
      outlineWidth: 2,
      outlineColor: 'var(--ctx-theme-contrast-page-200)'
    },
    link: {
      stroke: '#000000',
      strokeWidth: 1,
      outlineWidth: 2,
      outlineColor: 'var(--ctx-theme-contrast-page-200)'
    },
    outline: {
      fill: 'none',
      stroke: '#000000',
      strokeWidth: 2,
      outlineWidth: 2,
      outlineColor: 'var(--ctx-theme-contrast-page-200)'
    },
    symbol: {
      fill: '#000000',
      outlineWidth: 2,
      outlineColor: 'var(--ctx-theme-contrast-page-200)'
    }
  }
}
